<table>
  @for (level of _finalData; track level) {
    <tr
      (click)="single() ? onSingleSelect(level) : 0"
      [attr.data-cy]="'area-tree-item-' + level.key"
      [ngClass]="{
        'single-selected': selection()[0] === level.key,
      }"
    >
      <td>
        <div class="input-wrapper">
          @if (single()) {
            <kendo-radiobutton
              class="px-3"
              [size]="'large'"
              (checkedChange)="onSingleSelect(level)"
              [checked]="selection()[0] === level.key"
            />
          } @else {
            <assist-checkbox
              [class.subselected]="childSelected(level)"
              [attr.id]="level.key"
              [checked]="level.selected"
              (change)="onSelect(level, !level.selected)"
            />
          }
        </div>
      </td>
      <td (click)="level.open = !level.open; $event.stopPropagation()" class="suplevel">
        @if (!level.open && level.children.length > 0) {
          <cue-icon [icon]="ICONS.cueCaretRight" />
        }
        @if (level.open && level.children.length > 0) {
          <cue-icon [icon]="ICONS.cueCaretDown" />
        }
        <span class="parent-label" (click)="onSingleSelect(level); $event.stopPropagation()"
          >{{ level.name | localizedString }}
        </span>
      </td>
    </tr>

    <ng-container
      [ngTemplateOutlet]="sublevel"
      [ngTemplateOutletContext]="{ $implicit: level, offset: 1, brightness: 100 }"
    />
    <ng-template #sublevel let-parent let-offset="offset" let-brightness="brightness">
      @if (parent.open) {
        @for (subLevel of parent.children; track subLevel) {
          <tr
            (click)="single() ? onSingleSelect(subLevel) : 0"
            [attr.data-cy]="'area-tree-item-' + subLevel.key"
            class="sublevel"
            [ngClass]="{
              'single-selected': selection()[0] === subLevel.key,
            }"
          >
            <td>
              <div class="input-wrapper">
                @if (single()) {
                  <kendo-radiobutton
                    class="px-3"
                    [size]="'large'"
                    (checkedChange)="onSingleSelect(subLevel)"
                    [checked]="selection()[0] === subLevel[key]"
                  />
                } @else {
                  <assist-checkbox
                    [class.subselected]="childSelected(subLevel)"
                    class="marianova-classa"
                    type="checkbox"
                    [attr.id]="subLevel.key"
                    [checked]="subLevel.selected"
                    (change)="onSelect(subLevel, !subLevel.selected)"
                  />
                }
              </div>
            </td>
            <td
              [style.padding-left]="subLevel.children.length > 0 ? offset * 25 + 'px' : offset * 25 + 8 + 'px'"
              (click)="subLevel.open = !subLevel.open; $event.stopPropagation()"
              [class]="subLevel.children.length > 0 ? 'suplevel' : 'with-line'"
            >
              @if (!subLevel.open && subLevel.children.length > 0) {
                <cue-icon [icon]="ICONS.cueCaretRight" />
              }
              @if (subLevel.open && subLevel.children.length > 0) {
                <cue-icon [icon]="ICONS.cueCaretDown" />
              }
              <span
                [class]="subLevel.children.length > 0 ? 'parent-label' : 'item-label'"
                (click)="onSingleSelect(subLevel); $event.stopPropagation()"
                >{{ subLevel.name | localizedString }}
              </span>
            </td>
          </tr>
          <ng-container
            [ngTemplateOutlet]="sublevel"
            [ngTemplateOutletContext]="{
              $implicit: subLevel,
              offset: offset + 1,
              brightness: brightness + 10,
            }"
          />
        }
      }
    </ng-template>
  }
</table>
